import { Form, Input, InputNumber, Spin, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux"; 
import { useState } from "react"; 
import svg65 from "../../../../assets/svg/svg65.svg";
import svg66 from "../../../../assets/svg/svg66.svg"; 
import Members2Table from "./Members2Table";
import toast from "react-hot-toast";
import { setcurrent, setMemberObj } from "../../../../features/obj/objSlice";

export default function Step2({ handleNext, handleBack, form }) {
  const dispatch = useDispatch();
  const {  saving } = useSelector((state) => state.auth);
  const { paymentGroups } = useSelector((state) => state.fetch);
 const {activeObj} = useSelector((state)=>state.obj)

 const [rowId, setRowId] = useState([]);

  const selectedGroup = paymentGroups?.find(
    (item) => item?.pgId === activeObj?.pgId
  );
  
  async function handleSubmitStep() {
    if(!rowId?.length){
      toast.error("Select members to make payment")
      return
    }
    await dispatch(setMemberObj(rowId))
    // await handleNext();
    await  dispatch(setcurrent(2));
    // try {
    //   // await form.validateFields([
    //   //   "orgName",
    //   //   "orgEmail",
    //   //   "orgMobile",
    //   //   "orgCounty",
    //   //   "orgKraPin",
    //   //   "orgTown",
    //   //   "orgLocation",
    //   //   "orgBizTypeId",
    //   // ]);
    //   await handleNext();
    // } catch {}
  }

  const handlePrev = async () => {
    await handleBack(); 
  };
 

  return (
    <>
      <div className="flex flex-col w-full h-full">
        <div className="mt-0 lg:px-10 px-3"> 
          <div className="paragraph mt-0 !text-[#3f4651]">
            Use this page to add and edit members before saving. To edit the table,
            click on a cell.Select members you wish to make payments
          </div>
        
          <Members2Table rowId={rowId} setRowId={setRowId}/> 
          {/* <div className="border  border-[#3f4651] w-full mt-8"></div> */}
        </div>

        <div className="bg-[rgba(31,45,61,0.03)] mt-0">
          <div className="pt-[1.44rem] pb-[2.44rem] w-full flex justify-between items-center lg:px-10 px-3">
            <div className="w-[150px] ">
              <button
                disabled={saving}
                onClick={handlePrev}
                type="button"
                className="cstm-btn flex items-center gap-x-2"
              >
                <img src={svg65} alt="svg65" /> Previous
              </button>
            </div>

            <div className="w-[110px] ">
              <button
                onClick={handleSubmitStep}
                disabled={saving}
                type="button"
                className={`flex cstm-btn-2 `}
              >
                {saving ? <Spin /> : "Next"} <img src={svg66} alt="svg66" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
